module.exports = __webpack_public_path__ + "img/noposter.8385da8e.jpg";